module.exports = __webpack_public_path__ + "img/logo.56d4bfc7.gif";